// extracted by mini-css-extract-plugin
export default {"blackBtn":"BlackButton_blackBtn__P6RVc","button":"BlackButton_button__lEFZ5"};